// extracted by mini-css-extract-plugin
export default {"row":"ProductsDashboard_row__gvZX0","col":"ProductsDashboard_col__BTWo8","card":"ProductsDashboard_card__DmwRW"};